export enum StatusDropDownItems {
    Active = "Active",
    Inactive = "Inactive"
}